import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'fill' })
export class ArrayFillPipe implements PipeTransform {
  transform(value: number, ...args: any[]): any {
    return new Array(value).fill(1);
  }
}
